import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-comment\">\n<rect y=\"3.05176e-05\" width=\"20\" height=\"18\" fill=\"white\" />\n<path d=\"M3 13.7966H8.24999L9.93934 15.433L11.4393 13.7966H17V3.43298H3V13.7966Z\" stroke=\"#BBBBBB\" stroke-linecap=\"round\" />\n<circle cx=\"7\" cy=\"8.45316\" r=\"0.75\" fill=\"#C4C4C4\" />\n<circle cx=\"10\" cy=\"8.45316\" r=\"0.75\" fill=\"#C4C4C4\" />\n<circle cx=\"13\" cy=\"8.45316\" r=\"0.75\" fill=\"#C4C4C4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol